var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import ErrorIllustration from '../error-illustration';
import { StyledFlex } from '../../../../styles/common';
import { StyledText, StyledTitle } from '../../../../styles/text';
var GenericError = function (_a) {
    var image = _a.image, titleKey = _a.titleKey, subtitleKey = _a.subtitleKey;
    var t = useTranslation().t;
    return (_jsx(Inset, __assign({ horizontal: "xxlarge", vertical: "large" }, { children: _jsxs(StyledFlex, __assign({ direction: "column", alignItems: "center", justifyContent: "center" }, { children: [image || _jsx(ErrorIllustration, {}), _jsx(Stack, { size: "large" }), _jsx(StyledTitle, __assign({ size: "medium", color: "black", whiteSpace: "pre-line", align: "center" }, { children: t(titleKey !== null && titleKey !== void 0 ? titleKey : 'error.header') })), _jsx(Stack, { size: "small" }), _jsx(StyledText, __assign({ align: "center", whiteSpace: "pre-line" }, { children: t(subtitleKey !== null && subtitleKey !== void 0 ? subtitleKey : 'error.subText') }))] })) })));
};
export default GenericError;
